import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const variants = {
  primary: "bg-ptf-primary text-ptf-bg hover:bg-ptf-secondary border border-ptf-primary",
  accent: "bg-ptf-accent text-ptf-primary hover:brightness-95 border border-ptf-accent",
  outline: "bg-transparent text-ptf-primary border border-ptf-primary/40 hover:bg-ptf-primary hover:text-ptf-bg",
  outlineLight: "bg-transparent text-ptf-bg border border-ptf-bg/40 hover:bg-ptf-bg hover:text-ptf-primary",
};

export default function PtfButton({
  children,
  to,
  href,
  onClick,
  variant = "primary",
  arrow = true,
  className = "",
  type,
  disabled,
  ...rest
}) {
  const base = `group inline-flex items-center gap-2 px-7 py-3.5 text-xs font-semibold uppercase tracking-[0.18em] transition-colors duration-300 ease-out disabled:opacity-50 disabled:cursor-not-allowed ${variants[variant]} ${className}`;

  const inner = (
    <>
      <span>{children}</span>
      {arrow && (
        <ArrowUpRight
          className="h-4 w-4 transition-transform duration-300 ease-out group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
          aria-hidden="true"
        />
      )}
    </>
  );

  if (to) return <Link to={to} className={base} {...rest}>{inner}</Link>;
  if (href) return <a href={href} className={base} {...rest}>{inner}</a>;
  return (
    <button type={type || "button"} onClick={onClick} disabled={disabled} className={base} {...rest}>
      {inner}
    </button>
  );
}
